export interface InactivityPinFormValues extends InactivityPins {
  invalidPin: boolean | undefined;
  showPin: boolean;
}

export interface InactivityPins {
  a: string | undefined;
  b: string | undefined;
  c: string | undefined;
  d: string | undefined;
  e: string | undefined;
  f: string | undefined;
}

export const PIN_LENGTH = 6;

export const names: (keyof InactivityPinFormValues)[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f"
];
